// extracted by mini-css-extract-plugin
module.exports = {"wrap":"main_wrap__2_llG","row":"main_row__3XWBk","img":"main_img__1A75h","item":"main_item__2D0K_"};